import React from 'react'
import { NewThisWeekList } from '../styles'
import Polaroid from './polaroids/Polaroid'
import type { ConnectorProps as ListProps } from '../../connectors/Collection'
import CollectionConnector from '../../connectors/Collection'
export default CollectionConnector(
  (props: ListProps): React.ReactElement<React.ComponentProps<any>, any> => {
    const { newThisWeekList } = props
    return (
      <NewThisWeekList>
        {newThisWeekList.slice(0, 5).map((collection, index) => {
          const { collectionTitle, collectionCount, collectionUrl, mainImage, thumbs } = collection
          return (
            <Polaroid
              collectionTitle={collectionTitle}
              collectionCount={collectionCount}
              collectionUrl={collectionUrl}
              imageUrl={mainImage}
              thumbs={thumbs}
              index={`collection-public-${index + 1}`}
              key={`collection-public-${index + 1}`}
            />
          )
        })}
      </NewThisWeekList>
    )
  }
)